import { Fragment, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Autocomplete, Button, DialogActions, Divider, Grid, TextField } from "@mui/material";
import DialogContent from '@mui/material/DialogContent';
import _ from "lodash";
import DP_Dropdown from "./DP_Dropdown";
import "./inventoryWarehouse.css";
import SelectTag from "./SelectTag";
import { getConfigProducts, backupConfigData, assignInventoryToVessel, getInventoryWarehouseVesselList, getLicenseTypes, getDpsDefaultActiveConfig, createVessel, getDeviceLatestEOSversion, postDeviceResgistrationActions, getInventoryWarehouseTableData } from '../../actions/Users/authenticateInventory';
import { getVesselEdgeTopologyProducts } from '../../actions/Users/authenticateDashboard';
import { getRegisterDeviceData, getRouterDidsData } from '../../actions/Users/authenticateOpenEdgeService';
import { FreeSoloCreateOption } from "./SelectConfig";
import { convertDateTimeIntoTimezone, checkT0Tier, getDataFromLocalStorage, getDecodeURI } from "../../utils/util";
import { CONFIRM_DIALOG_TITLE, SERVICE_FUNCTION_TO_FEATURE } from "../../config";
import { MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from "../../utils/constants";
import { GET_DPS_DEFAULT_ACTIVE_CONFIG, GET_LICENSE_TYPES, GET_BACKUP_CONFIG_DATA, CREATE_AND_ASSIGN_INVENTORY, ASSIGN_INVENTORY_TO_VESSEL, DEVICE_LATEST_EOS_VERSION } from "../../actions/types";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export const AssignInventory = (props) => {
const {
    authReducer,
    deviceOu,
    backupConfigData, getRouterDidsData, assignInventoryToVessel, getRegisterDeviceData, getInventoryWarehouseVesselList, getLicenseTypes, getDpsDefaultActiveConfig, createVessel, getDeviceLatestEOSversion, postDeviceResgistrationActions, getInventoryWarehouseTableData,
    row, tab, setOpen, tabName, location
} = props;

const [isGoldenConfigNotApplied, setIsGoldenConfigNotApplied] = useState(true);
const [configSelectedValues, setConfigSelectedValue] = useState<any>({});
const [checkInputValue, setCheckInputValue] = useState(false);
const [readOnly, setReadOnly] = useState(true);
const [configOptions, setConfigOptions]=useState<any>([]);
const [vesselNames, setVesselNames] = useState<any[]>([]);
const [isT0License, setIsT0License] = useState<boolean>(false)

const [licenseTermTypes, setLicenseTermTypes] = useState<any>({});
const [defaultConfigDetails, setDefaultConfigDetails] = useState<any>({})
const [routerIds, setRouterIds] = useState([]);

const [createdSiteId, setCreatedSiteId] = useState('');
const [createdSiteName, setCreatedSiteName] = useState('');
const [registerObj, setRegisterObj] = useState({});
const [ou, setOu] = useState<any>({});
const [contactName, setContactName] = useState("");
const [contactEmail, setContactEmail] = useState("");
const [idData, setIdData] = useState<any>({ Site: { label: '', id: '' }, Device: { label: '', id: '' }, Configuration: { label: '', id: '' } })
const [siteValue, setSiteValue] = useState<any>({});
const [isCreate, setIsCreate] = useState(false);
const [isGoldenConfigApplied, setIsGoldenConfigApplied] = useState(false);
const [isGoldenConfigOtherApplied, setIsGoldenGonfigOtherApplied] = useState(false);
const [value, setValue] = useState<any>(null);
const [selectedLicense, setSelectedLicense] = useState<any>(null)
const [selectedTerm, setSelectedTerm] = useState<any>(null)
const [licenseOptions, setLicenseOptions] = useState<any[]>([])
const [termOptions, setTermOptions] = useState<any[]>([])
const [isUpgradeToLatestEosSelected, setIsUpgradeToLatestEosSelected] = useState(false);
const [selectedDeviceLatestEosVersion, setSelectedDeviceLatestEosVersion] = useState<any>("Fetching data...");
const [deviceAliasName, setDeviceAliasName] = useState<String>("");
const [selectedRouter, setSelectedRouter] = useState<any>({});
const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    onConfirm: () => { },
});

const dispatch = useDispatch();
const userOu = JSON.parse((localStorage.getItem('user_ou'))?.toString() || '')
const VIEW_INVENTORY = "view-inventory";
const viewWarehouseService = SERVICE_FUNCTION_TO_FEATURE[VIEW_INVENTORY]['service'];
const viewwarehouseFunction = SERVICE_FUNCTION_TO_FEATURE[VIEW_INVENTORY]['function'];
let _q = getDecodeURI(location?.search);

useEffect(() => {
    if (!_.isEmpty(selectedLicense)) {
        let termTypes = licenseTermTypes[selectedLicense?.value]
        setTermOptions(termTypes)
        if(termTypes && Array.isArray(termTypes) && termTypes.length > 0){
            setSelectedTerm(termTypes[0])
        }

        if (selectedLicense?.licenseTier) {
            setIsT0License(checkT0Tier(selectedLicense?.licenseTier))
        }
    }
}, [selectedLicense])

useEffect(() => {
    if (!_.isEmpty(authReducer.getLicenseTypes) && authReducer.getLicenseTypes?.data) {
        let licenseTypes = authReducer.getLicenseTypes.data
        if (licenseTypes && Array.isArray(licenseTypes) && licenseTypes.length > 0) {
            let types : any[] = []
            let termTypes = {}
            let defaultLicense = {}

            licenseTypes = _.orderBy(licenseTypes, ['tierOrder'],['asc']);

            if(!_.isEmpty(licenseTypes) && Array.isArray(licenseTypes) && licenseTypes.length > 0){ 
                if(!_.isEmpty(licenseTypes[0]) && licenseTypes[0]?.tierAlias && licenseTypes[0]?.tierType && licenseTypes[0]?.licenseTier){
                    defaultLicense = {
                        "label": licenseTypes[0].tierAlias,
                        "value" : licenseTypes[0].tierType,
                        "licenseTier": licenseTypes[0].licenseTier
                    }
                }
            }

            licenseTypes.forEach(tierType => {
                let type = {
                    "label": tierType?.tierAlias,
                    "value" : tierType?.tierType,
                    "licenseTier": tierType?.licenseTier
                }

                if(tierType?.term && Array.isArray(tierType.term) && tierType.term.length > 0){
                    let termOptions : any[] = []

                    tierType.term = _.orderBy(tierType.term, ['termOrder'],['asc']);
                    tierType.term.forEach(durationtype => {
                        let option = {
                            "label" : durationtype?.termDisplay,
                            "value" : durationtype?.termValue
                        }
                        termOptions.push(option)
                    });
                    termTypes[tierType?.tierType] = termOptions
                }

                types.push(type)
            });
            setLicenseTermTypes(termTypes)
            setLicenseOptions(types)
            setSelectedLicense(defaultLicense)
        } else {
            clearLicenceSelection()
            setLicenseTermTypes({})
        }
        dispatch({ type: GET_LICENSE_TYPES, payload: {} })
    }
}, [authReducer.getLicenseTypes])

useEffect(() => {
    if (!_.isEmpty(authReducer.getDpsDefaultActiveConfig) && authReducer.getDpsDefaultActiveConfig?.data) {
        let activeConfigs = authReducer.getDpsDefaultActiveConfig.data
        let isDefaultConfigFound= false
        if (activeConfigs && Array.isArray(activeConfigs) && activeConfigs.length > 0) {
            setDefaultConfigDetails(activeConfigs[0])
            isDefaultConfigFound = true
        } else {
            setDefaultConfigDetails({})
        }

        if (!isDefaultConfigFound && isGoldenConfigApplied) {
            setIsGoldenConfigApplied(false);
            setIsGoldenConfigNotApplied(true);
            setIsGoldenGonfigOtherApplied(false);
        }

        dispatch({ type: GET_DPS_DEFAULT_ACTIVE_CONFIG, payload: {} })
    }
}, [authReducer.getDpsDefaultActiveConfig])

useEffect(() => {
    if (!_.isEmpty(authReducer.getInventoryWarehouseVesselList)) {
        let data = authReducer.getInventoryWarehouseVesselList.hasOwnProperty("locations") && Array.isArray(authReducer.getInventoryWarehouseVesselList.locations) ? authReducer.getInventoryWarehouseVesselList.locations : [];
        let _k4Ids: any = []
        const vessels = data?.map((vs) => {
            _k4Ids.push(vs.id);
            return { label: vs.name, id: vs.id }
        })
        setVesselNames(vessels);
        let sitesIds = _k4Ids.join(',')
        setConfigOptions([])
        let status = "completed"
        sitesIds && backupConfigData(sitesIds, -1, -1, '', 'create_time', 'desc', '', row.productType, '', true, status, authReducer?.selectedOu?.id);
        authReducer.getInventoryWarehouseVesselList = {}
    }
}, [authReducer.getInventoryWarehouseVesselList])

useEffect(() => {
    if (!_.isEmpty(authReducer.backupConfigData)) {
        const data = authReducer?.backupConfigData?.result;
        setConfigOptions(data?.map((ele) => {
            return { label: ele.config_name, id: ele.id, details:ele }
        }));
        dispatch({ type: GET_BACKUP_CONFIG_DATA, payload: {} })
    }
}, [authReducer.backupConfigData])

const handleGoldenConfigApply = (e) => {
    if (e.target.value == 'Yes') {
        setIsGoldenConfigApplied(true);
        setIsGoldenConfigNotApplied(false);
        setIsGoldenGonfigOtherApplied(false);
        setReadOnly(true);
    } else if (e.target.value == 'Other') {
        setIsGoldenConfigApplied(false);
        setIsGoldenConfigNotApplied(false);
        setIsGoldenGonfigOtherApplied(true);
        setReadOnly(false);
    } else {
        setIsGoldenConfigApplied(false);
        setIsGoldenConfigNotApplied(true);
        setIsGoldenGonfigOtherApplied(false);
    }
}

const handleChangeConfigFrom = (e, newValue, key) => {
    let previousValue = configSelectedValues;
    let selectedValue = { ...idData, [`${key}`]: newValue };
    if (!newValue) {
        previousValue = { ...previousValue, Configuration: '' };
        selectedValue = { ...idData, Configuration: { label: '', id: '' } };
    } else {
        previousValue = { ...previousValue, Configuration: e.target.innerText.trim() };
        selectedValue = { ...idData, Configuration: newValue };
    }

    setIdData(selectedValue);
    setConfigSelectedValue({ ...previousValue });
}

useEffect(() => {
    if (!_.isEmpty(siteValue) && siteValue?.id) {
        getRouterDidsData(siteValue?.id)
    }
}, [siteValue])

useEffect(() => {
    if (!_.isEmpty(authReducer?.getRouterDids)) {
        const data = authReducer?.getRouterDids?.data;
        const filteredData = data?.map((item) => { return { 'deviceAlias': item.deviceAlias, 'router_did': item.deviceId } });
        if (filteredData?.length == 1) {
            setSelectedRouter(filteredData?.[0]);
        }
        setRouterIds(filteredData);
    }
}, [authReducer.getRouterDids])

const isEligibleToRegister = (
    siteValue &&
    (
        isGoldenConfigApplied ||
        (isGoldenConfigOtherApplied && configSelectedValues.Configuration) ||
        isGoldenConfigNotApplied
    ) &&
   (
        selectedLicense &&
        (
            selectedLicense.licenseTier !== 'T103' ||
            (selectedLicense.licenseTier === 'T103' && selectedRouter?.deviceAlias)
        )
    )
);

useEffect(() => {
    const _loggedInUser: any = getDataFromLocalStorage("loggedInUser");
    if (_loggedInUser) {
        const loggedInUser = JSON.parse(_loggedInUser);
        if (loggedInUser?.data?.user) {
            setContactName(`${loggedInUser?.data?.user?.name?.givenName} ${loggedInUser?.data?.user?.name?.familyName}`)
        }
    }
}, []);

useEffect(() => {
    const _loggedInUser: any = getDataFromLocalStorage("loggedInUser");
    if (_loggedInUser) {
        const loggedInUser = JSON.parse(_loggedInUser);
        if (loggedInUser?.data?.user) {
            setContactEmail(`${loggedInUser?.data?.user.userName}`)
        }
        // setIsAuthorizedToBeta(checkLoggedInUserAuthorizedToViewPage(betaFeatureService, betaFeatureFunction));
    }
}, []);

const handleOu = (ou: any) => {
    setValue(null);
    setOu(ou)
    getInventoryWarehouseVesselList(ou.name, '', viewWarehouseService, viewwarehouseFunction);
    clearLicenceSelection()
    getLicenseTypes(ou.id, row["deviceId"])
    getDpsDefaultActiveConfig(ou.id, row.deviceId)
    setIdData({ Site: { label: '', id: '' }, Device: { label: '', id: '' }, Configuration: { label: '', id: '' } });
}

useEffect(() => {
  if (!_.isEmpty(authReducer.assignInventoryToVessel)) {
    if(authReducer.assignInventoryToVessel.status == 1 && authReducer.assignInventoryToVessel.error_code == 10043) {
      const payload = {...registerObj, validated: true};
      setConfirmDialog({
        isOpen: true,
        title: CONFIRM_DIALOG_TITLE,
        subTitle: authReducer.assignInventoryToVessel?.message,
        onConfirm: () => {
          assignInventoryToVessel(row.deviceId, payload)
          setOpen(false);
        },
      })
    }
    else if(authReducer.assignInventoryToVessel.hasOwnProperty("status") && authReducer.assignInventoryToVessel.status==1){
      if (row?.deviceId?.startsWith('RS') || row?.deviceId?.startsWith('RM')) {
        getRegisterDeviceData(row.deviceId, selectedLicense?.licenseTier == 'T103' ? 'ap' : 'router', selectedRouter?.router_did, isCreate ? createdSiteId : siteValue?.id)  
      }
      setOpen(false);
      if (tabName == 'warehouse') {
        getInventoryWarehouseTableData(authReducer.selectedOu?.id, _q.search, 1, 15, 'shipmentDate', 'desc');
      }

      let siteId = isCreate ? createdSiteId : siteValue?.id
      let deviceId= row?.deviceId

      const payload: any = {
        upgradeToLatestEOS: false,
        applyConfig : false,
      }

      if (isUpgradeToLatestEosSelected) {
        payload.upgradeToLatestEOS= true
      }

      if (isGoldenConfigApplied || (isGoldenConfigOtherApplied && idData?.Configuration?.id)) {
        payload.applyConfig = true
        if (isGoldenConfigOtherApplied && idData?.Configuration?.id) {
          payload.configId = idData?.Configuration?.id
        }
      }
      // post registration actions
      postDeviceResgistrationActions(siteId,deviceId,payload)
    } else {
      setOpen(false);
    }
    dispatch({ type: ASSIGN_INVENTORY_TO_VESSEL, payload: {}})
  }
}, [authReducer.assignInventoryToVessel]);

useEffect(() => {
  if (!_.isEmpty(authReducer.createVessel)) {
    if(authReducer.createVessel.hasOwnProperty("status") && authReducer.createVessel.status==1){
      let payload = {
        "loc": authReducer.createVessel.hasOwnProperty("data") && authReducer.createVessel.data.name ,
        "k4Id": authReducer.createVessel.hasOwnProperty("data") && authReducer.createVessel.data.k4Id,
    }
    payload["setTierTerm"] = {
      "tier": selectedLicense?.value,
      "tierAlias" : selectedLicense?.label,
      "termValue": selectedTerm?.value,
      "dpIdd": ou.id
    }

    if (!_.isEmpty(deviceAliasName)) {
      payload["jsonArr"]=[
        {
          "deviceAliasName": deviceAliasName
        }
      ]
    }

    setRegisterObj(payload);
    setCreatedSiteId(authReducer?.createVessel?.data?.k4Id)
    setCreatedSiteName(authReducer?.createVessel?.data?.name)
    if(authReducer?.createVessel?.data?.k4Id) {
      getRouterDidsData(authReducer?.createVessel?.data?.k4Id)
    }
    // assignInventoryToVessel(row.deviceId , payload)   
    }
    dispatch({ type: CREATE_AND_ASSIGN_INVENTORY, payload: {}})
  }
}, [authReducer.createVessel]);

const handleAssignInventory = () => {
  if(createdSiteId || siteValue?.id) {
    let payload = {
      "loc": createdSiteName ? createdSiteName : siteValue?.label || null,
      "k4Id": createdSiteId ? createdSiteId : siteValue?.id || null,
    }
    payload["setTierTerm"] = {
      "tier": selectedLicense?.value,
      "tierAlias" : selectedLicense?.label,
      "termValue": selectedTerm?.value,
      "dpIdd": ou.id
    }

    if (!_.isEmpty(deviceAliasName)) {
      payload["jsonArr"]=[
        {
          "deviceAliasName": deviceAliasName
        }
      ]
    }

    setRegisterObj(payload);
    assignInventoryToVessel(row.deviceId , payload)
  }
}

const handleCreateAndAssignInventory = (siteValue) => {
  if(siteValue) {
    let payload = {
      "vesselName": siteValue,
      "contactName": contactName,
      "contactEmail":contactEmail,
      "k4DpId": ou.id,
      "source": "SPORT"
    }
    createVessel(contactEmail, payload)
  }
}

const clearLicenceSelection = () => {
    setSelectedLicense(null)
    setSelectedTerm(null)
    setLicenseOptions([])
    setTermOptions([])
  }

    useEffect(() => {
        if (!_.isEmpty(row?.deviceId)) {
            getDeviceLatestEOSversion(row.deviceId)
        }
    }, [row])

useEffect(() => {
    if (!_.isEmpty(authReducer?.deviceLatestEosVersion)) {
        if (!_.isEmpty(authReducer.deviceLatestEosVersion?.data)) {
            let eosVersion = authReducer.deviceLatestEosVersion?.data?.app_version;
            if (!_.isEmpty(eosVersion)) {
                eosVersion = eosVersion.split("~")[0]
                eosVersion = eosVersion.toLowerCase().startsWith("v") ? eosVersion : "v" + eosVersion
                setSelectedDeviceLatestEosVersion(eosVersion)
            } else {
                setSelectedDeviceLatestEosVersion("")
            }
        }
        dispatch({ type: DEVICE_LATEST_EOS_VERSION, payload: {} })
    }
}, [authReducer?.deviceLatestEosVersion])

const handleClose = () => {
    setDeviceAliasName("")
    setIsUpgradeToLatestEosSelected(false)
    setIsGoldenConfigApplied(false)
    setIsGoldenGonfigOtherApplied(false)
    setIdData({})
    setOpen(false);
    setConfirmDialog({ ...confirmDialog, subTitle: '', isOpen: false });
}

const handleConfirmClick = () => {
    confirmDialog.onConfirm();
}


return (
    <div className="Form assignInventory-container warehouseOrgDropdown">
        {confirmDialog.isOpen && <div className="custom_confirm_dialog_sub_title edit-actions-subTitle" style={tab == 'deployed-RS' ? {margin: '20px'} : {}}>
            {confirmDialog.subTitle}
            <div className="edit-actions-confirm-btns" style={tab?.includes('deployed') ? {width: '82%', borderTop: '1px solid rgba(0, 0, 0, 0.12)', justifyContent: 'end'} : {}}>
                <Divider className="confirm-dialogue-new-divider" />
                <div className="confirm-dialogue-new-btns">
                    <Button className="confirm-dialogue-cancel" onClick={() => setConfirmDialog({ ...confirmDialog, isOpen: false })}> Cancel </Button>
                    {
                        !authReducer.setAssignInventoryToVessel ? (
                            <Button className="confirm-dialogue-proceed" onClick={() => handleConfirmClick()}>
                                Proceed
                            </Button>
                        ) : (
                            <Button className="confirm-dialogue-proceed-notAllow">
                                Proceed
                            </Button>
                        )
                    }
                </div>
            </div>
        </div>}
        {!confirmDialog.isOpen && <>
            <DialogContent className={tab == 'deployed-RS' ? 'dialogue-content-register-deployed' : ''}>
                <Grid container className="deploy-inventory-content register-inventory-content">
                    <Grid className="selectedDeviceDetails">
                        <Grid>Select/Create a site from below to assign <span className="selectedProductType">{`(${row.deviceId})`}</span></Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} className="config-select-site-deploy">
                        <span id="content-left-text">Select Organization</span>
                        <DP_Dropdown isSmall={true} isReports={false} setOu={handleOu} deviceOu={deviceOu} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} className="select-site-check" >
                        <div>
                            <span id="content-left-text">Create / Search Site</span>
                            <FreeSoloCreateOption vesselNames={vesselNames} check={setCheckInputValue} setSiteValue={setSiteValue} setIsCreate={setIsCreate} value={value} setValue={setValue} handleCreateAndAssignInventory={handleCreateAndAssignInventory} setSelectedLicense={setSelectedLicense} setSelectedRouter={setSelectedRouter} />
                        </div>
                        <span className={checkInputValue ? "input-text-char-check" : ''}>{checkInputValue ? `Character " ' " is Not allowed` : ''}</span>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} className="select-site-check" >
                        <div>
                            <span id="content-left-text">Device name</span>
                            <TextField
                                placeholder="Enter Device name"
                                className="audit-filter-inputs-usage config-textField register-device-alias-name"
                                variant="outlined"
                                value={deviceAliasName}
                                onChange={(e) => setDeviceAliasName(e.target.value)}
                                autoComplete="off"
                            />
                        </div>
                    </Grid>
                    {
                        licenseOptions && licenseOptions.length > 0
                            ? <Grid item xs={12} sm={12} md={12} lg={12} className="select-site-check" >
                                <div className="margintop-10px">
                                    <span id="content-left-text">Select License</span>
                                    <Autocomplete
                                        freeSolo
                                        disableClearable
                                        forcePopupIcon={true}
                                        popupIcon={<KeyboardArrowDownIcon />}
                                        ListboxProps={{ className: 'warehouse-apply-config-props' }}
                                        className="audit-filter-inputs-usage config-textField"
                                        selectOnFocus
                                        clearOnBlur
                                        handleHomeEndKeys
                                        size='small'
                                        options={licenseOptions}
                                        value={selectedLicense}
                                        onChange={(e, newValue) => { setSelectedLicense(newValue) }}
                                        renderInput={({ inputProps, ...params }) => (
                                            <TextField {...params} placeholder="select"
                                                inputProps={{ ...inputProps, readOnly: true }}
                                            />
                                        )}
                                    />
                                </div>
                            </Grid>
                            : null
                    }
                    {
                        !isT0License && termOptions && termOptions.length > 0
                            ? <Grid item xs={12} sm={12} md={12} lg={12} className="select-site-check" >
                                <div className="margintop-10px">
                                    <span id="content-left-text">Select Term</span>
                                    <Autocomplete
                                        freeSolo
                                        disableClearable
                                        forcePopupIcon={true}
                                        popupIcon={<KeyboardArrowDownIcon />}
                                        ListboxProps={{ className: 'warehouse-apply-config-props' }}
                                        className="audit-filter-inputs-usage config-textField"
                                        selectOnFocus
                                        clearOnBlur
                                        handleHomeEndKeys
                                        size='small'
                                        options={termOptions}
                                        value={selectedTerm}
                                        onChange={(e, newValue) => { setSelectedTerm(newValue) }}
                                        renderInput={({ inputProps, ...params }) => (
                                            <TextField {...params} placeholder="select"
                                                inputProps={{ ...inputProps, readOnly: true }}
                                            />
                                        )}
                                    />
                                </div>
                            </Grid>
                            : null
                    }
                    {
                        selectedLicense?.licenseTier == 'T103'
                            ? <Grid item xs={12} sm={12} md={12} lg={12} className="select-site-check" >
                                <div className="margintop-10px">
                                    <span id="content-left-text">Routers</span>
                                    <Autocomplete
                                        freeSolo
                                        disableClearable
                                        forcePopupIcon={true}
                                        popupIcon={<KeyboardArrowDownIcon />}
                                        ListboxProps={{ className: 'warehouse-apply-config-props' }}
                                        className="audit-filter-inputs-usage config-textField"
                                        selectOnFocus
                                        clearOnBlur
                                        handleHomeEndKeys
                                        size='small'
                                        options={routerIds}
                                        value={selectedRouter}
                                        onChange={(e, newValue) => { setSelectedRouter(newValue) }}
                                        getOptionLabel={(option) => option?.deviceAlias || ""}
                                        renderInput={({ inputProps, ...params }) => (
                                            <TextField {...params} placeholder="select"
                                                inputProps={{ ...inputProps, readOnly: true }}
                                            />
                                        )}
                                    />
                                </div>
                            </Grid>
                            : null
                    }
                    {selectedLicense?.licenseTier == 'T103' && routerIds?.length == 0 && <Grid className="domain_name_validation_err_message" item xs={12} sm={12} md={12} lg={12} pt={0.5} pb={0.5}>Please configure at least one router to register as an Access Point (AP)</Grid>}
                    {!isT0License && <Grid item xs={12} sm={12} md={12} lg={12} className="name-input-default-config config-apply-config-deploy edit-reg-radio-btn" id='addMarginBottom'>
                        {
                            <Fragment>
                                <span id="content-left-text">Upgrade EOS
                                    {
                                        !_.isEmpty(row) && row?.deviceId
                                        ? <span>({selectedDeviceLatestEosVersion})</span>
                                        : null
                                    }
                                </span>
                                <div className="radioButton config-radio-button"> <input value='Yes' type="radio" onChange={() => setIsUpgradeToLatestEosSelected(true)} checked={isUpgradeToLatestEosSelected} /> <span>Yes</span> </div>
                                <div className="radioButton config-radio-button"> <input value='Yes' type="radio" onChange={() => setIsUpgradeToLatestEosSelected(false)} checked={!isUpgradeToLatestEosSelected} /> <span>No</span> </div>
                            </Fragment>
                        }
                    </Grid>}
                    {!isT0License && (!row?.deviceId?.startsWith('RS') || !row?.deviceId?.startsWith('RM')) && <Grid item xs={12} sm={12} md={12} lg={12} className="name-input-default-config config-apply-config-deploy edit-reg-radio-btn" id={isGoldenConfigNotApplied ? 'addMarginBottom' : 'removeMarginBottom'} >
                        {<Fragment>
                            <span id="content-left-text">Apply Default Config</span>
                            {
                                !_.isEmpty(defaultConfigDetails) ?
                                    <div className="radioButton config-radio-button"> <input value='Yes' type="radio" onChange={handleGoldenConfigApply} checked={isGoldenConfigApplied} /> <span>Yes</span> </div>
                                    : <div className="radioButton config-radio-button" title="No active default config found"> <input value='Yes' type="radio" checked={false} disabled /> <span>Yes</span> </div>
                            }
                            <div className="radioButton config-radio-button"> <input value='No' type="radio" onChange={handleGoldenConfigApply} checked={isGoldenConfigNotApplied} /> <span>No</span> </div>
                            <div className="radioButton config-radio-button"> <input value='Other' type="radio" onChange={handleGoldenConfigApply} checked={isGoldenConfigOtherApplied} /> <span>Other</span> </div>
                        </Fragment>}
                    </Grid>}
                    {isGoldenConfigOtherApplied ? <Grid item xs={12} sm={12} md={12} lg={12} className="config-configuration-form-deploy" >
                        {<Fragment>
                            <span id="content-left-text">Select Configuration</span>
                            <Grid className="configuration-form-build">
                                <div><SelectTag options={configOptions} handleChange={(e, newValue) => handleChangeConfigFrom(e, newValue, 'Configuration')} value={idData.Configuration} /> </div>
                            </Grid>
                        </Fragment>}
                    </Grid> : null}
                    {isGoldenConfigOtherApplied ? <Grid item xs={12} sm={12} md={12} lg={12} className="selected-config-details" >
                        {!_.isEmpty(idData.Configuration) && !_.isEmpty(idData.Configuration.details) ? <Fragment>
                            <div className="new-selected-config-details">
                                <Grid item xs={12} sm={12} md={12} lg={12} className="config-apply-config-target" style={tab == 'deployed-ES' ? {height: '20px'} : {}} >
                                    <span id="content-left-text">Site</span>
                                    <Grid id="content-right-text">
                                        <div title={idData.Configuration.details.site_name}>{idData.Configuration.details.site_name}</div>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} className="config-apply-config-target" style={tab == 'deployed-ES' ? {height: '20px'} : {}} >
                                    <span id="content-left-text">Device</span>
                                    <Grid id="content-right-text">
                                        <div title={idData.Configuration.details.device_name}>{idData.Configuration.details.device_name}</div>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} className="config-apply-config-target" style={tab == 'deployed-ES' ? {height: '20px'} : {}} >
                                    <span id="content-left-text">EOS Version</span>
                                    <Grid id="content-right-text">
                                        <div title={idData.Configuration.details.software_version}>{idData.Configuration.details.software_version}</div>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} className="config-apply-config-target" style={tab == 'deployed-ES' ? {height: '20px'} : {}} >
                                    <span id="content-left-text">Creation Date</span>
                                    <Grid id="content-right-text">
                                        <div title={convertDateTimeIntoTimezone(idData.Configuration.details.create_time, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)}>{convertDateTimeIntoTimezone(idData.Configuration.details.create_time, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)}</div>
                                    </Grid>
                                </Grid>
                            </div>
                        </Fragment> : null}
                    </Grid> : null}
                    {
                        isGoldenConfigOtherApplied && !_.isEmpty(defaultConfigDetails)
                            ?
                            <Grid item xs={12} sm={12} md={12} lg={12} className="config-configuration-form-deploy selected-config-details" >
                                <span id="content-left-text">Default Configuration details</span>
                                <Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} className="config-apply-config-target register-remove-margin-top" >
                                        <span id="content-left-text">Config Name</span>
                                        <Grid id="content-right-text">
                                            <div title={defaultConfigDetails?.config_name}>{defaultConfigDetails?.config_name}</div>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} className="config-apply-config-target register-remove-margin-top" >
                                        <span id="content-left-text">Site</span>
                                        <Grid id="content-right-text">
                                            <div title={defaultConfigDetails?.site_name}>{defaultConfigDetails?.site_name}</div>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} className="config-apply-config-target register-remove-margin-top" >
                                        <span id="content-left-text">Device</span>
                                        <Grid id="content-right-text">
                                            <div title={defaultConfigDetails?.device_name}>{defaultConfigDetails?.device_name}</div>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} className="config-apply-config-target register-remove-margin-top" >
                                        <span id="content-left-text">EOS Version</span>
                                        <Grid id="content-right-text">
                                            <div title={defaultConfigDetails?.software_version}>{defaultConfigDetails?.software_version}</div>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} className="config-apply-config-target register-remove-margin-top" >
                                        <span id="content-left-text">Creation Date</span>
                                        <Grid id="content-right-text">
                                            <div title={convertDateTimeIntoTimezone(defaultConfigDetails?.create_time, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)}>{convertDateTimeIntoTimezone(defaultConfigDetails?.create_time, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)}</div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            : null
                    }
                </Grid>
            </DialogContent>
            <DialogActions>
                <div className="register-edit-actions-confirm-btns">
                    <Divider className="confirm-dialogue-new-divider" />
                    <div className="confirm-dialogue-new-btns">
                        <Button className="confirm-dialogue-cancel" onClick={handleClose}> Cancel </Button>
                        <Button className={isEligibleToRegister ? 'confirm-dialogue-proceed' : 'confirm-dialogue-proceed-notAllow'}
                            disabled={!isEligibleToRegister}
                            onClick={() => {
                                setConfirmDialog({
                                    isOpen: true,
                                    title: CONFIRM_DIALOG_TITLE,
                                    subTitle: `Confirm to register ${row.productType} (${row.deviceId}) on site ${siteValue.label} ?`,
                                    onConfirm: () => {
                                        handleAssignInventory()
                                    },
                                })
                        }}>Register</Button>
                    </div>
                </div>
            </DialogActions>
        </>}
    </div>
  )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
});
export default withRouter(
    connect(mapStateToProps, { getConfigProducts, getVesselEdgeTopologyProducts, backupConfigData, getRouterDidsData, assignInventoryToVessel, getRegisterDeviceData, getInventoryWarehouseVesselList, getLicenseTypes, getDpsDefaultActiveConfig, createVessel, getDeviceLatestEOSversion, postDeviceResgistrationActions, getInventoryWarehouseTableData })(AssignInventory)
);